module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_8023.2fe57dd8.png";